a<template>
    <form-group
            :name="name"
            :label="label"
            :help-text="helpText"
            :error="error"
            :label-width="labelWidth"
            :input-width="inputWidth"
    >
        <gallery-widget
                :value="value"
                :nullable="nullable"
                @input="$emit('input', $event)"
        ></gallery-widget>
    </form-group>
</template>

<script>
    import FormGroup from "@/vendor/forms/FormGroups/Horizontal/FormGroup"
    import GalleryWidget from "@/components/FormGroups/Widgets/Gallery"

    export default {
        components: { FormGroup,GalleryWidget},

        props: {
            "name": {},
            "label": {},
            "helpText": {"default": null},
            "value": {},
            "error": {},
            "nullable": {},
            "labelWidth": {},
            "inputWidth": {}
        },
    }
</script>
